import React, { useState, useEffect, useContext } from 'react';
import 'react-tiny-fab/dist/styles.css';
import { useNavigate } from "react-router-dom";
import { getWebClient } from '../helpers/Helpers.js';
import Spinner from './components/Spinner';
import PromptError from './components/PromptError.js';
import Navbutton from './components/Navbutton.js';
import { MainSettingsContext } from '../App.js';

export default function DashboardRateReadOnly({ setAuthenticationToken }) {

    const { locationAndDates } = useContext(MainSettingsContext);

    const [viewMode, setViewMode] = useState('waiting');

    const [profile, setprofile] = useState(
        {
            company: "",
            city: "",
            country: "",
            typologyId: "",
            personInCharge: "",
            telephone: "",
            email: "",
            website: "",
            description: ""
        }
    );

    const navigate = useNavigate();

    const client = getWebClient();

    useEffect(() => {

        client.get(`/api/getprofile`)
            .then(function (response) {
                setprofile(response.data);
                setViewMode('');
                window.scrollTo(0, 0);
            })
            .catch(function (error) {
                console.log(error);
                setViewMode('error');
            });

    }, []);

    function getRateButton(isSeller) {
        if (isSeller) {
            return (<li> <button className="btn btn-primary buyer-btn" onClick={handleRateClick}>Rate your partners</button> </li>);
        } else {
            return;
        }
    }

    function handleAgendaClick() {
        navigate("/print");
    }
    function handleRateClick() {
        navigate("/ratings");
    }

    function handleLogoutClick() {
        setAuthenticationToken(null);
        localStorage.removeItem("authenticationToken");
        sessionStorage.removeItem("searchParams");
        sessionStorage.removeItem("searchResults");
    }

    return (
        <>

            <section className="main-sec">
                <header className="header">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <img src="assets/images/logo.svg" alt="" />
                        </div>
                        <div className="col-md-6">
                            <h2>Workshop Agenda</h2>
                            <p>{locationAndDates}</p>
                        </div>
                    </div>
                </header>
                <div className="main-container">
                    <h1 className="main-heading">{profile.company}</h1>
                    <p className="main-pera">Welcome in your private area!</p>
                    <ul className="btn-list">
                        <li> <button className="btn btn-secondary pro-btn" onClick={handleAgendaClick}>Your Agenda</button> </li>
                        { getRateButton(profile.seller) }
                    </ul>
                    <div className="main-card">
                        <h1>From this page you will be able to:</h1>
                        <div className="row">
                            <div className="col-md-12 mb-3 mt-3">
                                <h6>PRINT YOUR AGENDA</h6>
                                <p>Clicking on the button “your agenda”, it will be possible to print the appointment list</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mb-3 mt-3">
                                <h6>RATE YOUR PARTNERS</h6>
                                <p>If applicable, clicking on the button “rate your partners”, it will be possible to rate your experience with partners</p>
                            </div>
                        </div>
                        <div className="col-md-12 text-center" style={{ marginTop: 20 }}>
                            <div className="back-btn">
                                <button className="btn btn-secondary" onClick={handleLogoutClick}>Log out</button>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer">
                    <ul>
                        <li>&copy; {new Date().getFullYear()} - PromAx Communication SA - <a target="_blank" rel="noreferrer" href='http://www.sihe.ch'>www.sihe.ch</a><br></br>Tel. 0041/91/6118070 - <a href="mailto:segreteria@sihe.ch">segreteria@sihe.ch </a></li>
                    </ul>
                </footer>
            </section>

            <Navbutton></Navbutton>

            <Spinner show={viewMode === 'waiting'}></Spinner>
            <PromptError show={viewMode === 'error'} setViewMode={setViewMode}></PromptError>
            
        </>
    );

}